export default "__VITE_ASSET__H5a5JFfx__"